export default __webpack_public_path__ + "static/media/ic-languages-spoken.1de453fb.svg";